import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import { withNamespaces } from "react-i18next";
import { ShieldUser, User } from "lucide-react";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import AppHeader from '../containers/AppHeader'
import StepBar from '../components/StepBar'
import { postCancelPrebooking } from '../actions/qrs'

class PhoneView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      phoneNumber: '',
      mail: '',
      zona: '1',
      accesible: 'NO',
      confirmReservation: false,
      newsletterAcceptance: false,
      qrsale: null,
      booking: null,
      lockerSelected: null,
      descriptionZone: null,
      selectedAccessibility: null,
      zoneSelected: null,
      selectedLocker: null,
      lockerAssigned: null,
      lockerPrice: null,
      paymentId: null,
      qrToken: null,
      lockerPin: null,
      lockerMatricula: null,
      lockerCustomer: null,
      lockerInvoice: null,
      qrType: "pay",
      qrMode: 0,
      customerName: '',
      idNumber: '',
      language: null,
      startDate: null,
      endDate: null,
      showExitDialog: false,
      pendingNavigation: null,
    }

    this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
    this.handleMailChange = this.handleMailChange.bind(this);
    this.handleCustomerNameChange = this.handleCustomerNameChange.bind(this);
    this.handleIdNumberChange = this.handleIdNumberChange.bind(this);
  }

  handlePhoneNumberChange(value, countryData) {
    let cleaned = value;

    if (countryData && countryData.dialCode) {
      const dc = countryData.dialCode;
      cleaned = cleaned.replace(/^\+/, '');

      if (cleaned.startsWith(dc) && cleaned.slice(dc.length).startsWith(dc)) {
        cleaned = cleaned.slice(dc.length);
      }

      const afterDc = cleaned.slice(dc.length);
      if (afterDc.startsWith('00' + dc)) {
        cleaned = dc + afterDc.slice(('00' + dc).length);
      }

      cleaned = cleaned.replace(/[^\d]/g, '');
    }

    this.setState({ phoneNumber: cleaned });
  }

  // Utility function to remove accents
  removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  // Updated method
  handleCustomerNameChange(event) {
    const customerName = this.removeAccents(event.target.value);
    this.setState({ customerName });
  }

  handleMailChange(event) {
    const mail = event.target.value;
    const isValidEmail = this.validateEmail(mail);
    this.setState({ mail, isValidEmail });
  }

  handleIdNumberChange(event) {
    this.setState({ idNumber: event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '') });
  }

  validateEmail(email) {
    // A simple email validation pattern using regular expression
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  goTo(e) {
    const {
      zoneSelected,
      descriptionZone,
      selectedAccessibility,
      selectedLocker,
      lockerPrice,
      lockerAssigned,
      lockerPin,
      lockerMatricula,
      lockerCustomer,
      lockerCustomerID,
      lockerMatrixId,
      qr,
      timeStamp,
      qrType,
      qrMode
    } = this.props.location.state;

    if (!this.isContinueDisabled()) {
      // User is advancing to payment — unblock navigation cleanly (no cancel)
      if (this.unblockHistory) this.unblockHistory();
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
      this.props.push('/PaymentView', {
        // PASSED VARS
        zoneSelected: zoneSelected,
        descriptionZone: descriptionZone,
        selectedAccessibility: selectedAccessibility,
        selectedLocker: selectedLocker,
        lockerPrice: lockerPrice,
        lockerAssigned: lockerAssigned,
        lockerPin: lockerPin,
        lockerMatricula: lockerMatricula,
        lockerCustomer: lockerCustomer,
        lockerCustomerID: lockerCustomerID,
        lockerMatrixId: lockerMatrixId,
        qr: qr,
        timeStamp: timeStamp,
        qrType: qrType,
        qrMode: qrMode,
        // PHONE VARS
        mail: this.state.mail,
        phoneNumber: this.state.phoneNumber,
        newsletterAcceptance: this.state.newsletterAcceptance,
        confirmReservation: this.state.confirmReservation,
        idNumber: this.state.idNumber,
        useRedsysInsite: this.props.qrData?.useRedsysInsite || false
      })
    }
  }

  componentDidMount() {
    // Block back navigation and tab close while a locker is pre-booked
    this.unblockHistory = history.block((location, action) => {
      this.setState({ showExitDialog: true, pendingNavigation: { location, action } });
      return false;
    });
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  componentWillUnmount() {
    if (this.unblockHistory) this.unblockHistory();
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  handleBeforeUnload = (e) => {
    e.preventDefault();
    e.returnValue = '';
  }

  cancelPrebookingAndLeave = () => {
    const { lockerAssigned, lockerMatrixId, qr } = this.props.location.state;
    if (this.unblockHistory) this.unblockHistory();
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    this.props.postCancelPrebooking({ LockerAssigned: lockerAssigned, LockerMatrixId: lockerMatrixId })
      .finally(() => {
        const { pendingNavigation } = this.state;
        if (pendingNavigation) {
          history.push(pendingNavigation.location);
        } else {
          history.push(`/qrsale/${qr}`);
        }
      });
  }

  stayOnPage = () => {
    this.setState({ showExitDialog: false, pendingNavigation: null });
  }

  isContinueDisabled() {
    const { qrData } = this.props;
    const requiresId = qrData?.requireIdNumber;
    const disabled = (
      (this.state.phoneNumber.length < 6) ||
      !this.state.isValidEmail ||
      !this.state.confirmReservation ||
      (requiresId && this.state.idNumber.length < 5)
    )
    return disabled;
  }

  render() {
    const { t, i18n, qrData } = this.props;
    const requiresId = qrData?.requireIdNumber;

    return (
      <React.Fragment>
      <div className="rentalBackground">
        <AppHeader />
        <div className="lockerContainer smartphone">
          <br></br>
          <h3 className="lockTitle">
            <span className="text-vw-dark">{t('DATOS DE RESPALDO')}</span>
          </h3>
          <div className="unified-form">
            <ShieldUser className="rental-phoneIcon" strokeWidth={1} />

            <div className="lockTitle">
              <span className="text-vw-semidark">{t('Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin')}</span>
            </div>

            {/* NAME */}
            {/* <div className="mt-2 rental-uf-row">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t('Nombre Completo*')}</span>
                <input className="rental-phoneInput"
                  name="name"
                  type="text"
                  value={this.state.customerName}
                  onChange={this.handleCustomerNameChange}
                  placeholder={t('Introduce tu nombre')}
                />
              </div>
            </div> */}

            {/* EMAIL */}
            <div className="rental-uf-row">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t('Email*')}</span>
                <input className="rental-phoneInput"
                  name="lockerEmail"
                  type="text"
                  value={this.state.mail}
                  onChange={this.handleMailChange}
                  autoCapitalize='none'
                  placeholder={t('Introduce tu email')}
                />
              </div>
            </div>

            {/* PHONE */}
            <div className="rental-uf-row">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t('Teléfono*')}</span>
                <PhoneInput
                  country="es" // default country code
                  value={this.state.phoneNumber}
                  onChange={this.handlePhoneNumberChange}
                  inputClass="rental-phoneInput" // style to match form
                  pattern="[0-9]*"
                  placeholder={t('Introduce tu teléfono')}
                  countryCodeEditable={false}
                />
              </div>
            </div>

            {/* ID NUMBER (conditional) */}
            {requiresId && (
              <div className="rental-uf-row">
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t('Documento de Identidad*')}</span>
                  <input className="rental-phoneInput"
                    name="idNumber"
                    type="text"
                    value={this.state.idNumber}
                    onChange={this.handleIdNumberChange}
                    autoCapitalize='characters'
                    placeholder={t('DNI / NIE / Pasaporte')}
                    maxLength={20}
                  />
                </div>
              </div>
            )}

            {/* CHECKBOX */}
            <div className='divCheckbox'>
              <input
                type="checkbox"
                id="confirmReservation"
                name="confirmReservation"
                checked={this.state.confirmReservation}
                onChange={() => this.setState({ confirmReservation: !this.state.confirmReservation })}
              />
              <div className="rental-slider"></div>
              <label htmlFor="confirmReservation" className='rental-slide-checkbox'>
                {t('Confirmo que he leído y acepto los')} <a
                  href="https://vacway.com/locker-terms.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="terms-link"
                >
                  {t('términos y condiciones')}
                </a>
              </label>
            </div>
            <div
              className={`col lockerPhoneButton ${this.isContinueDisabled() ? "disabled" : ""}`}
              onClick={(e) => this.goTo(1, e)}
            >
              {t("Continuar")}
            </div>
            <div className="mt-2 w-100 text-center">
              <span className="text-vw-semidark rental-phone-advert">{t('*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.')}</span>
            </div>
          </div>
          <br></br>
          <StepBar step={3} />
        </div>

        <div className="lockerContainer pc">
          <h3 className="lockTitle">
            <span className="text-vw-dark">{t('DATOS DE RESPALDO')}</span>
          </h3>
          <div className="rental-phoneForm">
            <ShieldUser className="rental-phoneIcon" strokeWidth={1} />
            <div className="lockTitle">
              <span className="text-vw-semidark">{t('Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin de esta en caso de que lo pierdas. Al email te llegará la confirmación de tu reserva.')}</span>
            </div>
            <br></br>
            <div className="row">
              <div className="col-6">
                {/* <span className="rental-uf-label">{t('Nombre Completo*')}</span>
                <input className="rental-emailInput"
                  name="name"
                  type="text"
                  value={this.state.customerName}
                  onChange={this.handleCustomerNameChange}
                />
                <br></br> */}
                <span className="rental-uf-label">{t('Email*')}</span>
                <input className="rental-emailInput"
                  name="lockerEmail"
                  type="text"
                  value={this.state.mail}
                  onChange={this.handleMailChange}
                  autoCapitalize='none'
                />
                <br></br>
                <span className="rental-uf-label">{t('Teléfono*')}</span>
                <div className="mt-2"></div>
                <PhoneInput
                  country="es" // default country code
                  value={this.state.phoneNumber}
                  onChange={this.handlePhoneNumberChange}
                  inputClass="rental-phoneInput" // style to match form
                  pattern="[0-9]*"
                  countryCodeEditable={false}
                />

                {/* ID NUMBER (conditional) */}
                {requiresId && (
                  <>
                    <br></br>
                    <span className="rental-uf-label">{t('Documento de Identidad*')}</span>
                    <input className="rental-emailInput"
                      name="idNumber"
                      type="text"
                      value={this.state.idNumber}
                      onChange={this.handleIdNumberChange}
                      autoCapitalize='characters'
                      placeholder={t('DNI / NIE / Pasaporte')}
                      maxLength={20}
                    />
                  </>
                )}
              </div>
              <div className="col-1">

              </div>
              <div className="col-5">
                <div className='divCheckbox'>
                  <input
                    type="checkbox"
                    id="confirmReservation"
                    name="confirmReservation"
                    checked={this.state.confirmReservation}
                    onChange={() => this.setState({ confirmReservation: !this.state.confirmReservation })}
                  />
                  <div className="rental-slider"></div>
                  <label htmlFor="confirmReservation" className='rental-slide-checkbox'>
                    {t('Confirmo que he leído y acepto los')} <a
                      href="https://vacway.com/locker-terms.html"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="terms-link"
                    >
                      {t('términos y condiciones')}
                    </a>
                  </label>
                </div>
                <div
                  className={`col lockerPhoneButton ${this.isContinueDisabled() ? "disabled" : ""}`}
                  onClick={(e) => this.goTo(1, e)}
                >
                  {t("Continuar")}
                </div>
              </div>
            </div>
            <div className="row w-100 text-center">
              <div className="mt-5 w-100 text-center">
                <span className="text-vw-semidark rental-phone-advert">{t('*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.')}</span>
              </div>
            </div>
          </div>
          <br></br>
          <StepBar step={3} />
        </div>
      </div>
      {this.state.showExitDialog && (
        <div className="time-exit-overlay">
          <div className="time-exit-dialog">
            <div className="time-exit-dialog-icon">⚠️</div>
            <h4 className="time-exit-dialog-title">{this.props.t('¿Seguro que quieres salir?')}</h4>
            <p className="time-exit-dialog-body">{this.props.t('Si abandonas ahora, tu taquilla reservada quedará libre y otro usuario podrá alquilarla.')}</p>
            <div className="time-exit-dialog-actions">
              <button className="time-exit-btn-stay" onClick={this.stayOnPage}>
                {this.props.t('Continuar con el alquiler')}
              </button>
              <button className="time-exit-btn-leave" onClick={this.cancelPrebookingAndLeave}>
                {this.props.t('Cancelar y salir')}
              </button>
            </div>
          </div>
        </div>
      )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  auth: true,
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  postCancelPrebooking: bindActionCreators(postCancelPrebooking, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PhoneView));
